
import { Target } from "lucide-react";
import { RadiusMatchingStats } from "@/hooks/useRadiusMatching";

interface MatchingSystemOverviewProps {
  hasNullData: boolean;
  stats?: RadiusMatchingStats | null;
}

export const MatchingSystemOverview = ({ hasNullData, stats }: MatchingSystemOverviewProps) => {
  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-600">
        Reports matched using enhanced hierarchical system: 60-mile radius → state → region → city matching
        {hasNullData && (
          <span className="text-orange-600 ml-2">
            ⚠️ Some reports have missing market data
          </span>
        )}
      </p>
      
      {/* Enhanced Matching System Overview */}
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
        <div className="flex items-center space-x-2 text-sm text-purple-800 mb-2">
          <Target size={16} />
          <span className="font-medium">Enhanced Hierarchical Matching System</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs text-purple-700">
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
            <span><strong>60-Mile Radius</strong> (Score: 90-100)</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <span><strong>State Match</strong> (Score: 75)</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span><strong>Regional Match</strong> (Score: 60)</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
            <span><strong>City Match</strong> (Score: 85)</span>
          </div>
        </div>
        
        {/* Display matching statistics if available */}
        {stats && (
          <div className="mt-3 pt-3 border-t border-purple-200">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-2 text-xs">
              <div className="text-center">
                <div className="font-medium text-purple-800">{stats.radiusMatches}</div>
                <div className="text-purple-600">Radius</div>
              </div>
              <div className="text-center">
                <div className="font-medium text-blue-800">{stats.stateMatches}</div>
                <div className="text-blue-600">State</div>
              </div>
              <div className="text-center">
                <div className="font-medium text-green-800">{stats.regionalMatches}</div>
                <div className="text-green-600">Regional</div>
              </div>
              <div className="text-center">
                <div className="font-medium text-orange-800">{stats.cityMatches}</div>
                <div className="text-orange-600">City</div>
              </div>
              <div className="text-center">
                <div className="font-medium text-purple-800">{stats.totalMatches}</div>
                <div className="text-purple-600">Total</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
